module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="';
 if (active) { 
__p+='active';
}
__p+='">'+
((__t=( label ))==null?'':__t)+
'</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/page-reports/list/templates/report-list-item.html
// module id = 456
// module chunks = 0